import React, { useState, useEffect, useContext, useRef } from "react";
import {
  Container,
  makeStyles,
  TableBody,
  TableHead,
  TablePagination,
  Grid,
} from "@material-ui/core";
import {
  Toast,
  ConfirmationModal,
  SimpleToolbar,
  AddOperator,
  EditOperator,
  Loader,
  AssignLabToOperator,
  Drawer,
  StyledTableCell,
  StyledTableRow,
  BaseTable,
} from "../components";
import {
  operatorServices,
  userServices,
  laboratoryServices,
} from "../services";
import { AuthContext } from "../context";
import { useDrawer } from "../hooks";
import {
  EditIconButton,
  EnableDisableIconButton,
  DeleteIconButton,
  AddUserIconButton,
} from "../components/icon-buttons";
import handleDownloadExcel from "../helpers/download-excel";
export default function OperatorsScreen(props) {
  const classes = useStyles();
  const [operators, setOperators] = useState([]);
  const [limit, setLimit] = useState(100);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const { authState, signOut } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [operatorToEdit, setOperatorToEdit] = useState(null);
  const [openEditOperatorModal, setOpenEditOperatorModal] = useState(false);
  const [openAddOperatorModal, setOpenAddOperatorModal] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [userId, setUserId] = useState(null);
  const [reload, setReload] = useState(false);
  const [openAssignOperator, setOpenAssignOperator] = useState(false);
  const [labs, setLabs] = useState([]);
  const [allLabs, setAllLabs] = useState([]);
  const { isOpen, setIsOpen } = useDrawer();
  const tableHeader = useRef([
    "Tipo",
    "Padre",
    "Nombre",
    "Correo",
    "RUT",
    "Contacto",
    "Teléfono",
    "Dirección",
  ]);
  const tableBody = useRef([]);
  useEffect(() => {
    const tableData = operators.map((operator) => {
      return {
        Tipo: operator.user.role._id,
        Padre: operator?.parentOperator?.name || "N/A",
        Nombre: operator.name,
        Correo: operator.user.email,
        RUT: operator.rut,
        Contacto: operator.contact,
        Teléfono: operator.phone,
        Dirección: operator.address,
      };
    });
    tableBody.current = tableData;
  }, [operators]);

  useEffect(() => {
    getOperators();
  }, [page, limit, authState, reload, signOut]);

  useEffect(() => {
    async function getLabs() {
      setReload(false);
      try {
        setLoading(true);
        const { status, response } =
          await laboratoryServices.getLabsWithoutOperators({
            token: authState.token,
          });
        const all = await laboratoryServices.getLaboratories({
          token: authState.token,
        });
        setLoading(false);
        if (status === 200) {
          setAllLabs(all.response.laboratories);
          setLabs(response.laboratories);
        } else if (status === 401) {
          signOut();
        }
      } catch (e) {
        setLoading(false);
        console.log(e);
      }
    }
    getLabs();
  }, [authState, signOut]);

  // useEffect(() => {
  //   async function getOperators() {
  //     setReload(false);
  //     try {
  //       setLoading(true);
  //       const { status, response } = await operatorServices.getOperators({
  //         token: authState.token,
  //         page,
  //         limit,
  //       });
  //       setLoading(false);
  //       if (status === 200) {
  //         setOperators(response.operators);
  //       } else if (status === 401) {
  //         signOut();
  //       }
  //     } catch (e) {
  //       setLoading(false);
  //       console.log(e);
  //     }
  //   }
  //   getOperators();
  // }, [page, limit, authState, reload, signOut]);

  const getOperators = async (text = "") => {
    setReload(false);
    try {
      setLoading(true);
      const { status, response } = await operatorServices.getOperatorsFilter({
        text,
        token: authState.token,
        page,
        limit,
      });
      setLoading(false);
      if (status === 200) {
        // console.log({ response });
        setOperators(response.operators);
        setLimit(response.limit);
        setCount(response.total);
        setPage(response.page);
      } else if (status === 401) {
        signOut();
      }
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  };
  const optionsToolbar = [
    {
      label: "Export excel",
      action: (e) => {
        handleDownloadExcel({
          filename: "Operadores",
          tableBody: tableBody.current,
          tableHeader: tableHeader.current,
        });
      },
    },
    {
      label: "Agregar",
      action: (e) => {
        setOpenAddOperatorModal(true);
      },
    },
  ];
  const updateStatus = async (operator) => {
    try {
      setLoading(true);
      const { status } = await userServices.updateUserStatus({
        _id: operator.user._id,
        status: !operator.user.status,
        token: authState.token,
      });
      setLoading(false);
      if (status === 200) {
        setReload(true);
        setToast(true);
        setToastMessage("Operador actualizado con exito");
      } else if (status === 401) {
        signOut();
      }
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  };

  const deleteOperator = async () => {
    try {
      setLoading(true);
      const { status, response } = await userServices.deleteUser({
        _id: userId,
        token: authState.token,
        type: "operator",
      });
      setLoading(false);
      if (status === 200) {
        setReload(true);
        setToast(true);
        setToastMessage(response.message);
      } else if (status === 401) {
        signOut();
      }
      if (response.error) {
        setToast(true);
        setToastMessage(response.error.message);
      }
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  };

  const handleClose = (value) => {
    setOpenEditOperatorModal(value);
    setOperatorToEdit(null);
  };

  const handleToast = (message, active) => {
    setToastMessage(message);
    setToast(active);
  };

  const confirmationModal = (_id) => {
    setOpenAlert(true);
    setUserId(_id);
  };

  const assignLab = (operator) => {
    setOperatorToEdit(operator);
    setUserId(operator._id);
    setOpenAssignOperator(true);
  };

  const addOperator = async (operator) => {
    try {
      setLoading(true);
      const { status, response } = await operatorServices.addOperator({
        token: authState.token,
        operator,
      });
      setLoading(false);
      switch (status) {
        case 201:
          setReload(true);
          setToast(true);
          setToastMessage(response.message);
          break;
        case 200:
          setToast(true);
          setToastMessage(response.error.message);
          break;
        case 400:
          setToast(true);
          setToastMessage(response.error.message);
          break;
        case 401:
          signOut();
          break;
        default:
          break;
      }
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  };

  const editOperator = async (_id, operator) => {
    try {
      setLoading(true);
      const { status, response } = await operatorServices.updateOperator({
        _id: _id,
        operator,
        token: authState.token,
      });
      setLoading(false);
      switch (status) {
        case 200:
          if (response.error) {
            setToast(true);
            setToastMessage(response.error.message);
          } else {
            setReload(true);
            setToast(true);
            setToastMessage(response.message);
          }
          break;
        case 400:
          setToast(true);
          setToastMessage(response.error.message);
          break;
        default:
          break;
      }
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  };

  const onSubmitAssignLabs = async (laboratories) => {
    try {
      setLoading(true);
      const { status, response } = await operatorServices.assignLaboratories({
        _id: userId,
        laboratories,
        token: authState.token,
      });
      setLoading(false);
      if (status === 200) {
        setToastMessage(response.message);
      } else {
        setToastMessage(response.error.message);
      }
      setToast(true);
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
    setReload(true);
  };

  function getOperatorType(roleId) {
    switch (roleId) {
      case "68e5bf44298b3633d59294bf":
        return "Sub-operador";
      case "602d4e260ecf5949dc06334e":
        return "Operador";
      default:
        return "Operador";
    }
  }

  return (
    <>
      <Drawer open={isOpen} setOpen={(value) => setIsOpen(value)} />
      <Grid container className={classes.container} style={{ flex: 1 }}>
        {loading && <Loader loading={loading} />}
        <Grid item sm={12} xs={12}>
          <div className={classes.root}>
            <ConfirmationModal
              open={openAlert}
              setOpenAlert={setOpenAlert}
              setConfirmAction={() => deleteOperator()}
            />
            <Toast
              message={toastMessage}
              open={toast}
              close={() => {
                setToast(false);
              }}
            />
            {openEditOperatorModal && (
              <EditOperator
                operator={operatorToEdit}
                open={openEditOperatorModal}
                close={() => handleClose(false)}
                editOperator={(_id, operator) => editOperator(_id, operator)}
              />
            )}
            {openAddOperatorModal && (
              <AddOperator
                addOperator={(operator) => addOperator(operator)}
                open={openAddOperatorModal}
                close={() => setOpenAddOperatorModal(false)}
                operatorsList={operators}
              />
            )}
            {openAssignOperator && (
              <AssignLabToOperator
                toast={(message, active) => {
                  handleToast(message, active);
                }}
                onSubmit={(laboratories) => onSubmitAssignLabs(laboratories)}
                open={openAssignOperator}
                labList={labs.concat(
                  allLabs.filter((lab) =>
                    operatorToEdit.laboratories.find(
                      (opLab) => opLab === lab._id
                    )
                  )
                )}
                operatorLabs={allLabs.filter((lab) =>
                  operatorToEdit.laboratories.find((opLab) => opLab === lab._id)
                )}
                close={() => setOpenAssignOperator(false)}
              />
            )}
            <Container maxWidth={false}>
              <SimpleToolbar
                onFilter={(text) => getOperators(text)}
                isOpen={isOpen}
                setIsOpen={(value) => setIsOpen(value)}
                options={optionsToolbar}
              />
              <BaseTable tableId="operatorsTable">
                <TableHead>
                  <StyledTableRow>
                    <StyledTableCell>Tipo</StyledTableCell>
                    <StyledTableCell>Padre</StyledTableCell>
                    <StyledTableCell>Nombre</StyledTableCell>
                    <StyledTableCell>Correo</StyledTableCell>
                    <StyledTableCell>Rut</StyledTableCell>
                    <StyledTableCell>Contacto</StyledTableCell>
                    <StyledTableCell>Teléfono</StyledTableCell>
                    <StyledTableCell>Dirección</StyledTableCell>
                    <StyledTableCell>Opciones</StyledTableCell>
                  </StyledTableRow>
                </TableHead>
                <TableBody>
                  {operators.map((operator, index) => (
                    <StyledTableRow hover key={operator._id}>
                      <StyledTableCell>
                        {getOperatorType(operator.user.role._id)}
                      </StyledTableCell>
                      <StyledTableCell>
                        {operator?.parentOperator?.name || "N/A"}
                      </StyledTableCell>
                      <StyledTableCell>{operator.name}</StyledTableCell>
                      <StyledTableCell>{operator.user.email}</StyledTableCell>
                      <StyledTableCell>{operator.rut}</StyledTableCell>
                      <StyledTableCell>{operator.contact}</StyledTableCell>
                      <StyledTableCell>{operator.phone}</StyledTableCell>
                      <StyledTableCell>{operator.address}</StyledTableCell>
                      <StyledTableCell>
                        <EditIconButton
                          tooltipTitle="Editar operador"
                          onClick={() => {
                            setOpenEditOperatorModal(true);
                            setOperatorToEdit(operator);
                          }}
                        />
                        <EnableDisableIconButton
                          status={operator.user.status}
                          tooltipTitleEnable="Activar operador"
                          tooltipTitleDisable="Desactivar operador"
                          onClick={() => updateStatus(operator)}
                        />
                        <DeleteIconButton
                          tooltipTitle="Borrar operador"
                          onClick={() => confirmationModal(operator.user._id)}
                        />
                        {operator.user.role._id ===
                          "602d4e260ecf5949dc06334e" && (
                          <AddUserIconButton
                            status={!operator.user.status}
                            onClick={() => assignLab(operator)}
                            tooltipTitle="Aisgnar laboratorio"
                          />
                        )}
                      </StyledTableCell>
                    </StyledTableRow>
                  ))}
                </TableBody>
              </BaseTable>
              <TablePagination
                labelRowsPerPage="Registros por página"
                component="div"
                count={count}
                onChangeRowsPerPage={(e) => {
                  setLimit(e.target.value);
                }}
                onChangePage={(e, page) => {
                  setPage(page + 1);
                }}
                page={page - 1}
                rowsPerPage={limit}
                rowsPerPageOptions={[10, 25, 50, 100]}
                classes={{ root: classes.pagination }}
              />
            </Container>
          </div>
        </Grid>
      </Grid>
    </>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    paddingBottom: theme.spacing(2),
    paddingTop: theme.spacing(2),
  },
  pagination: {
    color: theme.palette.secondary.main,
    [theme.breakpoints.down("xs")]: {
      position: "absolute",
      bottom: 0,
    },
  },
}));
